import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useCurrencyExchangeLogic = () => {
  const apiRoute = "currencyexchange";
  const onlyForm = undefined;
  const initFields = [
    {
      name: "primary_currency",
      label: "Primary Currency",
      type: "dropdown",
      isRequired: true,
      err: "Primary Currency is required",
      returnID: true,
    },
    {
      name: "secondary_currency",
      label: "Secondary Currency",
      type: "dropdown",
      isRequired: true,
      err: "Secondary Currency is required",
      returnID: true,
    },
    {
      name: "rate_multiply",
      label: "Rate Multiply",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Rate Multiply is required",
    },
    {
      name: "valid_from",
      label: "Valid From",
      type: "datepicker",
      isRequired: true,
      allowTime: true,
      err: "Valid From is required",
      relatedWith: "expiry_date",
    },
    {
      name: "expiry_date",
      label: "Expiry",
      type: "datepicker",
      isRequired: false,
      allowTime: true,
      err: "Expiry is required",
      minDate: "valid_from",
      isClearable: true,
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;

  ///Add,Delete,Edit Roles
  const addRoles = [admin];
  const deleteRoles = [admin];
  const editRoles = [admin];

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(
        config,
        "currencies",
        "primary_currency",
        temp,
        "code",
        "symbol"
      ),
      fetchDataAndMapToField(
        config,
        "currencies",
        "secondary_currency",
        temp,
        "code",
        "symbol"
      ),
    ];
  };

  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    getPromises,
    onlyForm,
  };
};

export default useCurrencyExchangeLogic;
